export {
	buildStructuredMemoryCompareData as buildRpcMemoryCompareData,
	buildStructuredMemoryHistoryData as buildRpcMemoryHistoryData,
	type MemorySnapshotContractContext as RpcMemoryContext,
} from "../../core/memory-snapshot-contract.js";
